import { Link } from 'components/atoms';
import { RootTitled } from 'components/templates';
import { NavList } from 'components/molecules';

export default function Play() {
  return (
    <RootTitled>
      <NavList>
        <Link to="/play/quick">Quick Play</Link>
        <Link to="/play/team">Team Play</Link>
        <Link to="/play/build">Build Play</Link>
      </NavList>
    </RootTitled>
  );
}
